import { Auth, Config, Installations, Payout, Products, PurchaseOrders, Services, UserProfile, Vendor } from "@client-shared/providers";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/auth-context";
import { FeatureFlagsProvider } from "./contexts/feature-flags-context";
import { TaxRatesProvider } from "./contexts/tax-rates-context";
import "./styles/globals.css";

// Initialize i18n
import "@bcc/lib/i18n";
import { BatchesProvider } from "./contexts/batches-context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Auth.SfdcAuthProvider>
          <Vendor.VendorProvider localeSource="country">
            <UserProfile.UserProfileProvider>
              <Services.ServicesProvider>
                <Config.ConfigProvider localeSource="country">
                  <Installations.InstallationsProvider>
                    <Products.ProductsProvider>
                      <PurchaseOrders.PurchaseOrdersProvider>
                        <BatchesProvider>
                          <Payout.PayoutProvider>
                            <AuthProvider>
                              <TaxRatesProvider>
                                <FeatureFlagsProvider>
                                  <App />
                                </FeatureFlagsProvider>
                              </TaxRatesProvider>
                            </AuthProvider>
                          </Payout.PayoutProvider>
                        </BatchesProvider>
                      </PurchaseOrders.PurchaseOrdersProvider>
                    </Products.ProductsProvider>
                  </Installations.InstallationsProvider>
                </Config.ConfigProvider>
              </Services.ServicesProvider>
            </UserProfile.UserProfileProvider>
          </Vendor.VendorProvider>
        </Auth.SfdcAuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
